const _prefix = '@error/';

export default {
  API_RESPONSE_ERROR: _prefix + 'API_RESPONSE_ERROR',
  SET_ERROR: _prefix + 'SET_ERROR'
};
